export default {"src":"/_next/static/media/norisk.5d8743b4.svg","height":113,"width":159,"blurWidth":0,"blurHeight":0};